const pearl = {
  title: 'Pearl',
  tips: 'Çekim bilgilerini ve miktarı kontrol edin',
  notice:
    'Gönderimden sonra iptal edilmesine izin verilmez. Lütfen hesap detayları ve miktarın doğruluğunu kontrol edin ve onaylayın.',
  selectUserTips: 'Çekilecek miktarı girin',
};

const information = {
  title: 'Bilgi',
  inputPlaceholder: 'Girin',
};

export default {
  title: 'Çekim',
  success: 'Başarıyla çekildi',
  successTips1: 'İstek işlenmesi 3 - 7 iş günü sürecek. Lütfen sabırlı olun.',
  successTips2: 'Resmi inceleme reddedilirse, bildirim alacaksınız ve miktar iade edilecektir.',
  placeholder: 'Çekilecek miktarı girin',
  withdrawInformation: 'Çekim Bilgileri',
  fee: 'Ücret: {{count}}%',
  pearl,
  information,
};
